import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ui-full" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-11"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "ui-table"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-10 ui-cell" }, " Característica "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-11 ui-cell" }, " Item/Valor "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-align-center" }, " Ações ")
], -1)
const _hoisted_10 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_11 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-10 ui-cell",
  "data-title": "Característica"
}
const _hoisted_12 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-11 ui-cell",
  "data-title": "Item/Valor"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["value", "onChange"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-3 ui-cell ui-actions-table",
  "data-title": "Ações"
}
const _hoisted_19 = { class: "ui-actions" }
const _hoisted_20 = { class: "ui-action ui-move" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_combo_caracteristica = _resolveComponent("combo-caracteristica")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_combo_caracteristica_item = _resolveComponent("combo-caracteristica-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.state.novaCaracteristica.tipo === undefined?'ant-col ant-col-xs-24 ant-col-xl-20':'ant-col ant-col-xs-24 ant-col-xl-9')
          }, [
            _createVNode(_component_a_form_item, { label: "Característica" }, {
              default: _withCtx(() => [
                _createVNode(_component_combo_caracteristica, {
                  codigo: _ctx.state.novaCaracteristica.codigoCaracteristica,
                  "onUpdate:codigo": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.novaCaracteristica.codigoCaracteristica) = $event)),
                  tipoCategoriaSelecionada: _ctx.state.novaCaracteristica.tipo,
                  "onUpdate:tipoCategoriaSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.novaCaracteristica.tipo) = $event))
                }, null, 8, ["codigo", "tipoCategoriaSelecionada"])
              ]),
              _: 1
            })
          ], 2),
          (_ctx.state.novaCaracteristica.tipo !== undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.verificaPreenchimentoCampoValor(_ctx.state.novaCaracteristica.codigoCaracteristica))
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 0,
                      label: "Valor"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.state.novaCaracteristica.tipo === _ctx.ETipoCaracteristica.Texto)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              class: "ant-input",
                              maxlength: "250",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.novaCaracteristica.valor) = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.state.novaCaracteristica.valor]
                            ])
                          : (_ctx.state.novaCaracteristica.tipo === _ctx.ETipoCaracteristica.Numero || _ctx.state.novaCaracteristica.tipo === _ctx.ETipoCaracteristica.Decimal)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 1,
                                type: "number",
                                class: "ant-input",
                                value: _ctx.state.valorNumerico,
                                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.novaCaracteristica.valor = String(($event.target as HTMLInputElement).value)))
                              }, null, 40, _hoisted_4))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : (_ctx.verificaPreenchimentoItem(_ctx.state.novaCaracteristica.codigoCaracteristica))
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 1,
                        label: "Selecione um item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_combo_caracteristica_item, {
                            codigo: _ctx.state.novaCaracteristica.codigoCaracteristicaItem,
                            "onUpdate:codigo": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.novaCaracteristica.codigoCaracteristicaItem) = $event)),
                            codigoCaracteristica: _ctx.state.novaCaracteristica.codigoCaracteristica,
                            subItens: false
                          }, null, 8, ["codigo", "codigoCaracteristica"])
                        ]),
                        _: 1
                      }))
                    : (_ctx.verificaPreenchimentoSubItem(_ctx.state.novaCaracteristica.codigoCaracteristica))
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 2,
                          label: "Selecione um Sub item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_caracteristica_item, {
                              codigo: _ctx.state.novaCaracteristica.codigoCaracteristicaItem,
                              "onUpdate:codigo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.novaCaracteristica.codigoCaracteristicaItem) = $event)),
                              codigoCaracteristica: _ctx.state.novaCaracteristica.codigoCaracteristica,
                              subItens: true
                            }, null, 8, ["codigo", "codigoCaracteristica"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_form_item, { label: " " }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "ui-button -primary ui-mh-32 ui-full",
                  type: "button",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.adicionarCaracteristica()))
                }, _hoisted_7)
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.computedCaracteristicas.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhuma característica foi adicionado ainda"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.computedCaracteristicas,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedCaracteristicas) = $event)),
                  "item-key": "index",
                  handle: ".ui-move"
                }, {
                  item: _withCtx(({element,index}) => [
                    (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "ant-row ui-row"
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_combo_caracteristica, {
                          codigo: element.codigoCaracteristica,
                          "onUpdate:codigo": ($event: any) => ((element.codigoCaracteristica) = $event),
                          tipoCategoriaSelecionada: element.tipo,
                          "onUpdate:tipoCategoriaSelecionada": ($event: any) => ((element.tipo) = $event),
                          disabled: true
                        }, null, 8, ["codigo", "onUpdate:codigo", "tipoCategoriaSelecionada", "onUpdate:tipoCategoriaSelecionada"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        (_ctx.verificaPreenchimentoCampoValor(element.codigoCaracteristica))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (_ctx.obtemTipoCaracteristica(element.codigoCaracteristica) === _ctx.ETipoCaracteristica.Texto)
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "text",
                                    class: "ant-input",
                                    maxlength: "250",
                                    "onUpdate:modelValue": ($event: any) => ((element.valor) = $event)
                                  }, null, 8, _hoisted_14)), [
                                    [_vModelText, element.valor]
                                  ])
                                : (_ctx.obtemTipoCaracteristica(element.codigoCaracteristica) === _ctx.ETipoCaracteristica.Numero || _ctx.obtemTipoCaracteristica(element.codigoCaracteristica) === _ctx.ETipoCaracteristica.Decimal)
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      type: "number",
                                      class: "ant-input",
                                      value: Number(element.valor),
                                      onChange: ($event: any) => (element.valor = String(($event.target as HTMLInputElement).value))
                                    }, null, 40, _hoisted_15))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_ctx.verificaPreenchimentoItem(element.codigoCaracteristica))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(_component_combo_caracteristica_item, {
                                  codigo: element.codigoCaracteristicaItem,
                                  "onUpdate:codigo": ($event: any) => ((element.codigoCaracteristicaItem) = $event),
                                  codigoCaracteristica: element.codigoCaracteristica,
                                  subItens: false,
                                  limparSelecao: false
                                }, null, 8, ["codigo", "onUpdate:codigo", "codigoCaracteristica"])
                              ]))
                            : (_ctx.verificaPreenchimentoSubItem(element.codigoCaracteristica))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_component_combo_caracteristica_item, {
                                    codigo: element.codigoCaracteristicaItem,
                                    "onUpdate:codigo": ($event: any) => ((element.codigoCaracteristicaItem) = $event),
                                    codigoCaracteristica: element.codigoCaracteristica,
                                    subItens: true,
                                    limparSelecao: false
                                  }, null, 8, ["codigo", "onUpdate:codigo", "codigoCaracteristica"])
                                ]))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_a_tooltip, { title: "Arraste para cima ou para baixo para ordenar as características" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_20, [
                                _createVNode(_component_icone, { nome: "ordenar-lista" })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tooltip, { title: "Deletar" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                class: "ui-action",
                                onClick: ($event: any) => (_ctx.removerCaracteristica(index))
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_21)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}